app.modalController = app.modalController || {};

app.modalController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.openModal();
        this.closeModal();
    },
    
    openModal : function () {
        var $openBtn = $('.openModal');
        
        if ($openBtn.length > 0) {
            $openBtn.each(function() {
                var $btn = $(this),
                    $modal = $('#'+$btn.data('modal'));
                
                $btn.on('click', function() {
                    $modal.removeClass('hidden').addClass('visible');
                });
            });
        }
    },
    
    closeModal : function () {
        var $closeBtn = $('.closeModal');
        
        if ($closeBtn.length > 0) {
            $closeBtn.each(function() {
                var $btn = $(this),
                    $modal = $('#'+$btn.data('modal'));
                
                $btn.on('click', function() {
                    $modal.removeClass('visible').addClass('hidden');
                });
            });
        }
    },

};
